import { TeesheetActionTypes } from "redux/actions/actionTypes";
import { ISlot, ITeeTime } from "../models/teetime";

export interface ITeeSheetAction {
  type: TeesheetActionTypes;
  payload: Partial<ITeeSheetState>;
}

export interface ITeeSheetState {
  teetimes: ITeeTime[];
  selectedDate: Date;
  selectedMenu: string;
  selectedCart: any;
  selectedTeeTimeSlot: ISlot;
  selectedTeeTime: ITeeTime;
  temporaryBooking: any;
}

const initialState: ITeeSheetState = {
  teetimes: [],
  selectedDate: null,
  selectedMenu: null,
  selectedCart: null,
  selectedTeeTimeSlot: null,
  selectedTeeTime: null,
  temporaryBooking: {},
};

export default function MasterTeeSheetReducer(state = initialState, action: ITeeSheetAction) {
  switch (action.type) {
    case TeesheetActionTypes.LOAD_TEETIMES_SUCCESS_MASTER:
      return { ...state, teetimes: action.payload as ITeeTime[] };

    case TeesheetActionTypes.SELECT_DATE_MASTER:
      return { ...state, selectedDate: action.payload };

    case TeesheetActionTypes.UPDATE_SELECTED_MENU_MASTER:
      return {
        ...state,
        ...action.payload,
      };
    case TeesheetActionTypes.UPDATE_SELECTED_CART_MASTER:
      return {
        ...state,
        ...action.payload,
      };
    case TeesheetActionTypes.UPDATE_SELECTED_TEETIME_SUCCESS_MASTER:
      return {
        ...state,
        ...action.payload,
      };
    case TeesheetActionTypes.UPDATE_BOOKING_TEMPORARY_MASTER:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
